import { render, staticRenderFns } from "./PersonalinfoComponent.vue?vue&type=template&id=798bf548"
import script from "./PersonalinfoComponent.vue?vue&type=script&lang=js"
export * from "./PersonalinfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports